export default {
  checkInterval: 'інтервал перевірки',
  newCommitCheckInterval: 'інтервал перевірки нового коміта',
  schedule: 'Розклад',
  newSchedule: 'Новий розклад',
  deleteSchedule: 'Видалити розклад',
  editSchedule: 'Редагувати розклад',
  backup: 'Резервна копія проєкту',
  downloadTheProjectBackupFile: 'Завантажити файл резервної копії проєкту.',
  restoreProject: 'Відновити проєкт...',
  incorrectUsrPwd: 'Неправильний логін або пароль',
  askDeleteUser: 'Ви дійсно бажаєте видалити цього користувача?',
  askDeleteTemp: 'Ви дійсно бажаєте видалити цей шаблон?',
  askDeleteEnv: 'Ви дійсно бажаєте видалити це середовище?',
  askDeleteInv: 'Ви дійсно бажаєте видалити цей інвентар?',
  askDeleteKey: 'Ви дійсно бажаєте видалити цей ключ?',
  askDeleteRepo: 'Ви дійсно бажаєте видалити цей репозиторій?',
  askDeleteProj: 'Ви дійсно бажаєте видалити цей проєкт?',
  askDeleteTMem: 'Ви дійсно бажаєте видалити цього члена команди?',
  askDeleteSchedule: 'Ви дійсно бажаєте видалити цей розклад?',
  edit: 'Редагувати',
  nnew: 'Новий',
  keyFormSshKey: 'SSH-ключ',
  keyFormLoginPassword: 'Логін з паролем',
  keyFormNone: 'Немає',
  incorrectUrl: 'Неправильний URL',
  username: "Ім'я користувача",
  username_required: "Ім'я користувача обов'язкове",
  dashboard: 'Панель керування',
  history: 'Історія',
  activity: 'Активність',
  settings: 'Налаштування',
  signIn: 'Увійти',
  password: 'Пароль',
  changePassword: 'Змінити пароль',
  editUser: 'Редагувати користувача',
  newProject: 'Новий проєкт',
  close: 'Закрити',
  newProject2: 'Новий проєкт...',
  demoMode: 'ДЕМО РЕЖИМ',
  task: 'Завдання #{expr}',
  youCanRunAnyTasks: 'Ви можете запускати будь-які завдання',
  youHaveReadonlyAccess: 'Ви маєте доступ лише для перегляду',
  taskTemplates: 'Шаблони завдань',
  inventory: 'Інвентар',
  environment: 'середовище',
  keyStore: 'Сховище ключів',
  repositories: 'Репозиторії',
  darkMode: 'Темний режим',
  team: 'Команда',
  users: 'Користувачі',
  editAccount: 'Редагувати обліковий запис',
  signOut: 'Вийти',
  error: 'Помилка',
  refreshPage: 'Оновити сторінку',
  relogin: 'Увійти ще раз',
  howToFixSigninIssues: 'Як виправити проблеми з входом',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Спочатку вам потрібно мати доступ до сервера, де запущено Semaphore.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Виконайте цю команду на сервері, щоб переглянути існуючих користувачів:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'Ви можете змінити пароль існуючого користувача:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Або створіть нового адміністратора:',
  close2: 'Закрити',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Немає облікового запису або не можете увійти?',
  password2: 'Пароль',
  cancel: 'Скасувати',
  noViews: 'Немає переглядів',
  addView: 'Додати перегляд',
  editEnvironment: 'Редагувати середовище',
  deleteEnvironment: 'Видалити середовище',
  newEnvironment: 'Нове середовище',
  environmentName: 'Назва середовища',
  dockerImage: 'Runner Docker Image (необов’язково)',
  extraVariables: 'Додаткові змінні',
  enterExtraVariablesJson: 'Введіть додаткові змінні JSON...',
  environmentVariables: 'Змінні середовища',
  enterEnvJson: 'Введіть env JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Змінні середовища та додаткові змінні повинні бути валідним JSON. Приклад:',
  dashboard2: 'Панель керування',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'Вибачте, але <%= htmlWebpackPlugin.options.title %> не працює належним чином без JavaScript. Будь ласка, увімкніть його.',
  deleteInventory: 'Видалити інвентар',
  newInventory: 'Новий інвентар',
  name: 'Назва',
  userCredentials: 'Облікові дані користувача',
  sudoCredentialsOptional: 'Облікові дані sudo (необов’язково)',
  type: 'Тип',
  pathToInventoryFile: 'Шлях до інвентарного файлу',
  enterInventory: 'Введіть інвентар...',
  staticInventoryExample: 'Приклад статичного інвентарю:',
  staticYamlInventoryExample: 'Приклад статичного YAML-інвентарю:',
  keyName: 'Ім’я ключа',
  loginOptional: 'Логін (необов’язково)',
  usernameOptional: "Ім'я користувача (необов’язково)",
  privateKey: 'Приватний ключ',
  override: 'Перезаписати',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Використовуйте цей тип ключа для HTTPS-репозиторіїв та для плейбуків з не-SSH підключенням.',
  deleteKey: 'Видалити ключ',
  newKey: 'Новий ключ',
  create: 'Створити',
  newTask: 'Нове завдання',
  cantDeleteThe: 'Не вдалося видалити {objectTitle}',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: '{objectTitle} не може бути видалено, оскільки використовується такими ресурсами:',
  projectName: 'Назва проєкту',
  allowAlertsForThisProject: 'Дозволити сповіщення для цього проєкту',
  telegramChatIdOptional: 'Telegram Chat ID (необов’язково)',
  maxNumberOfParallelTasksOptional: 'Максимальна кількість паралельних завдань (необов’язково)',
  deleteRepository: 'Видалити репозиторій',
  newRepository: 'Новий репозиторій',
  urlOrPath: 'URL або шлях',
  absPath: 'абс. шлях',
  branch: 'Гілка',
  accessKey: 'Ключ доступу',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Облікові дані для доступу до Git-репозиторію. Має бути:',
  ifYouUseGitOrSshUrl: 'якщо ви використовуєте Git або SSH URL.',
  ifYouUseHttpsOrFileUrl: 'якщо ви використовуєте HTTPS або file URL.',
  none: 'Немає',
  ssh: 'SSH',
  deleteProject: 'Видалити проєкт',
  save: 'Зберегти',
  deleteProject2: 'Видалити проєкт',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Після видалення проєкту повернення неможливе. Будьте впевнені.',

  clear_cache: 'Очистити кеш',
  clear_cache_message: 'Видалити всі кеш-файли, пов’язані з цим проєктом. Ця дія незворотна.',

  name2: 'Ім’я *',
  title: 'Заголовок *',
  description: 'Опис',
  required: 'Обов’язково',
  key: '{expr}',
  surveyVariables: 'Змінні опитування',
  addVariable: 'Додати змінну',
  vaultName: 'Vault ID (необов’язково)',
  vaultNameDefault: 'Може бути лише один `default` (пусте) ім’я',
  default_value: 'Значення за замовчуванням',
  vaultNameUnique: 'Має бути унікальним',
  vaultTypePassword: 'Пароль',
  vaultTypeScript: 'Клієнтський скрипт',
  vaultScript: 'Шлях до скрипта',
  vaultScriptRequired: 'Вкажіть шлях до скрипта',
  vaultScriptClientRequired: 'Шлях до скрипта має закінчуватись на \'-client\' і розширення',
  vaults: 'Сховища',
  vaultAdd: 'Додати сховище',
  vaultRequired: 'Пароль сховища обов’язковий',
  columns: 'Колонки',
  buildVersion: 'Версія збірки',
  messageOptional: 'Повідомлення (необов’язково)',
  debug: 'Налагодження',
  dryRun: 'Тестовий запуск',
  diff: 'Порівняння',
  advanced: 'Додатково',
  hide: 'Сховати',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Дозвольте перевизначення CLI аргументу в налаштуваннях шаблону завдання',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI-аргументи (JSON-масив). Приклад: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Запущено',
  author: 'Автор',
  duration: 'Тривалість',
  stop: 'Зупинити',
  forceStop: 'Зупинити примусово',
  raw_log: 'Сире логи',
  confirmTask: 'Підтвердити',
  deleteTeamMember: 'Видалити члена команди',
  team2: 'Команда',
  newTeamMember: 'Новий член команди',
  user: 'Користувач',
  administrator: 'Адміністратор',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Визначає початкову версію артефакту. З кожним запуском версія збільшується.',
  forMoreInformationAboutBuildingSeeThe: 'Детальніше про збірку дивіться',
  taskTemplateReference: 'Довідник по шаблонах завдань',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Визначає який артефакт буде розгорнуто при запуску завдання.',
  forMoreInformationAboutDeployingSeeThe: 'Детальніше про розгортання дивіться',
  taskTemplateReference2: 'Довідник по шаблонах завдань',
  definesAutorunSchedule: 'Визначає розклад автозапуску.',
  forMoreInformationAboutCronSeeThe: 'Детальніше про cron дивіться на',
  cronExpressionFormatReference: 'Посилання на формат cron-виразів',
  startVersion: 'Початкова версія',
  example000: 'Приклад: 0.0.0',
  buildTemplate: 'Шаблон збірки',
  autorun: 'Автозапуск',
  playbookFilename: 'Шлях до файлу playbook *',
  exampleSiteyml: 'Приклад: deploy/site.yml',
  inventory2: 'Інвентар *',
  repository: 'Репозиторій',
  environment3: 'середовище *',
  vaultPassword: 'Пароль сховища',
  vaultPassword2: 'Пароль сховища',
  view: 'Перегляд',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Я хочу запускати завдання по розкладу лише для нових комітів певного репозиторія',
  repository2: 'Репозиторій',
  cronChecksNewCommitBeforeRun: 'Cron перевіряє новий коміт перед запуском',
  readThe: 'Читайте',
  toLearnMoreAboutCron: 'щоб дізнатися більше про cron.',
  suppressSuccessAlerts: 'Не показувати сповіщення про успіх',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI-аргументи (JSON-масив). Приклад: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI-аргументи',
  docs: 'документація',
  editViews: 'Редагувати перегляди',
  newTemplate: 'Новий шаблон',
  taskTemplates2: 'Шаблони завдань',
  all: 'Усі',
  notLaunched: 'Не запущено',
  by: 'від {user_name}',
  editTemplate: 'Редагувати шаблон',
  newTemplate2: 'Новий шаблон',
  deleteTemplate: 'Видалити шаблон',
  playbook: 'Playbook',
  email: 'Email',
  adminUser: 'Адміністратор',
  sendAlerts: 'Відправляти сповіщення',
  deleteUser: 'Видалити користувача',
  newUser: 'Новий користувач',
  re: 'Пере{getActionButtonTitle}',
  teamMember: '{expr} член команди',
  taskId: 'ID завдання',
  version: 'Версія',
  status: 'Статус',
  start: 'Почати',
  actions: 'Дії',
  alert: 'Сповіщення',
  admin: 'Адмін',
  role: 'Роль',
  external: 'Зовнішній',
  time: 'Час',
  path: 'Шлях',
  gitUrl: 'Git-URL',
  sshKey: 'SSH-ключ',
  lastTask: 'Останнє завдання',
  task2: 'Завдання',
  build: 'Збірка',
  deploy: 'Розгортання',
  run: 'Запуск',
  add: 'Додати',
  password_required: 'Пароль обов’язковий',
  name_required: 'Ім’я обов’язкове',
  user_credentials_required: 'Облікові дані користувача обов’язкові',
  type_required: 'Тип обов’язковий',
  path_required: 'Шлях до інвентарного файлу обов’язковий',
  private_key_required: 'Приватний ключ обов’язковий',
  project_name_required: 'Назва проєкту обов’язкова',
  repository_required: 'Репозиторій обов’язковий',
  branch_required: 'Гілка обов’язкова',
  key_required: 'Ключ обов’язковий',
  user_required: 'Користувач обов’язковий',
  build_version_required: 'Версія збірки обов’язкова',
  title_required: 'Заголовок обов’язковий',
  isRequired: 'обов’язково',
  mustBeInteger: 'Має бути ціле число',
  mustBe0OrGreater: 'Має бути 0 або більше',
  start_version_required: 'Початкова версія обов’язкова',
  playbook_filename_required: 'Потрібно вказати playbook',
  inventory_required: 'Необхідно вказати інвентар',
  environment_required: 'середовище обов’язкове',
  email_required: 'Email обов’язковий',
  build_template_required: 'Шаблон збірки обов’язковий',
  Task: 'Завдання',
  Build: 'Збірка',
  Deploy: 'Розгортання',
  Run: 'Запуск',
  ReBuild: 'Перезібрати',
  ReDeploy: 'Перерозгорнути',
  ReRun: 'Перезапустити',
  CreateDemoProject: 'Створити демо-проєкт',
  LeaveProject: 'Вийти з проєкту',
  integration: 'Інтеграція',
  integrations: 'Інтеграції',
  NewIntegration: 'Нова інтеграція',
  EditIntegration: 'Редагувати інтеграцію',
  DeleteIntegration: 'Видалити інтеграцію',
  DeleteIntegrationMsg: 'Ви впевнені, що хочете видалити цю інтеграцію?',
  AddAlias: 'Додати псевдонім',
  LoadAlias: 'Завантаження псевдонімів...',
  globalAlias: 'Використовувати псевдонім проєкту',
  matcher: 'Аналізатор',
  matchType: 'Тип співпадіння',
  newMatcher: 'Новий аналізатор',
  matchMethod: 'Спосіб порівняння',
  matchBodyDataType: 'Тип даних у тілі',
  extractValue: 'Витягнути значення',
  newExtractedValue: 'Нове витягнуте значення',
  extractedValueSource: 'Джерело значення',
  matchKey: 'Ключ',
  matchValue: 'Значення',
  matchOn: 'Порівнювати за',
  runners: 'Виконавці',
  newRunner: 'Новий виконавець',
  enabled: 'Увімкнено',
  scheduleNextRun: 'Наступний запуск',
  maxNumberOfParallelTasks: 'Максимум паралельних завдань',
  runnerUsage: 'Використання:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Токен:',
  editRunner: 'Редагувати виконавця',
  deleteRunner: 'Видалити виконавця',
  newRunnerToken: 'Новий токен виконавця',
  askDeleteRunner: 'Ви дійсно бажаєте видалити виконавця {runner}?',
  roles_only_enterprise: 'Ролі доступні лише у <b>Enterprise</b> версії.',
  project_runners_only_pro: 'Виконавці проєкту доступні лише для <b>PRO</b> користувачів.',
  secret_storage_only_pro: 'Сховище секретів доступне лише у <b>PRO</b> версії.',
  foss_runners_limited: 'Open-source версія має обмежені функції, повний функціонал доступний у <b>PRO</b> версії.',
  learn_more_about_pro: 'Дізнатися більше',
  upgrade_to_pro: 'Оновити',
  contact_admin_to_upgrade: 'Зверніться до адміністратора для активації PRO-функцій.',
  contact_admin_to_upgrade_enterprise: 'Зверніться до адміністратора для активації функцій Enterprise.',
  projectRestoreResult: 'Результати відновлення проєкту',
  projectWithNameRestored: 'Проєкт {projectName} успішно відновлено.',
  pleaseUpdateAccessKeys: 'Оновіть їх перед запуском завдань.',
  emptyKeysRestored: 'Додано {emptyKeys} пустих ключів.',
  template: 'Шаблон',
  aliasUrlCopied: 'URL псевдоніма скопійований до буфера.',
  yes: 'Так',
  activeTasks: 'Активні завдання',
  taskLocation: 'Розташування',
  empty: 'Порожньо',
  noValues: 'Немає значень',
  addArg: 'Додати аргумент',

  status_success: 'Успішно',
  status_failed: 'Помилка',
  status_stopped: 'Зупинено',

  api_tokens: 'API-токени',

  auto_approve: 'Автоматичне підтвердження',
  auto_destroy: 'Дозволити знищення',
  terraform_override_backend: 'Перезапис параметрів бекенду',
  terraform_backend_filename: 'Ім\'я файлу бекенду (за замовчуванням: backend.tf)',
  terraform_invalid_backend_filename: 'Некоректне ім\'я файлу бекенду',

  tag: 'Тег',
  tag_required: 'Тег обов\'язковий',
  allowInventoryInTask: 'Інвентар',
  allowLimitInTask: 'Обмеження',
  addLimit: 'Додати обмеження',
  allowDebug: 'Налагодження',
  addTag: 'Додати тег',
  skipTags: 'Пропустити теги',
  addSkippedTag: 'Додати пропущений тег',
  tags: 'Теги',
  limit: 'Обмеження',

  runner_tag: 'Тег виконавця',
  allow_parallel_tasks: 'Дозволити паралельні завдання',
  task_prompts: 'Підказки',
  template_advanced: 'Додаткові опції',
  template_app_options: 'Опції {app}',
  template_app_prompts: 'Підказки для {app}',
  general_settings: 'Загальні налаштування',
  danger_zone_settings: 'Небезпечна зона',
  project_stats: 'Статистика проєкту',
  allow_override_branch: 'Гілка',
  template_common_options: 'Загальні опції',

  template_tasks: 'Завдання',
  template_details: 'Деталі',
  template_tf_workspaces: 'Workspaces',

  slug: 'Слаг',
  slug_required: 'Слаг обов’язковий',
  slugHint: 'Унікальний ідентифікатор (лише малими літерами, латиницею, цифри, нижнє підкреслення і дефіс)',
  invalidSlugFormat: 'Слаг має бути малими літерами, латиницею, цифри, нижнє підкреслення чи дефіс',
  permissions: 'Права',
  canRunProjectTasks: 'Може запускати завдання проєкту',
  canUpdateProject: 'Може оновлювати проєкт',
  canManageProjectResources: 'Може керувати ресурсами проєкту',
  canManageProjectUsers: 'Може керувати користувачами проєкту',
  newRole: 'Нова роль',
  editRole: 'Редагувати роль',
  deleteRole: 'Видалити роль',
  askDeleteRole: 'Ви дійсно бажаєте видалити цю роль?',
  Roles: 'Ролі',
  role_required: 'Роль обов’язкова',

  templatePermission: 'Права шаблону',
};
